export const name = 'john pribyl'
export const title = 'software engineer'
